export default __webpack_public_path__ + "static/media/image_shre_edit.687173ec.svg";